// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Own-profile pages (client, admin, subadmin). Scoped under .profile-page. */

.profile-page {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  min-width: 0;
}

.profile-page__identity {
  display: flex;
  align-items: center;
  gap: var(--ds-space-4);
  min-width: 0;
}

.profile-page__identity .ant-avatar {
  flex-shrink: 0;
}

.profile-page__who {
  min-width: 0;
}

.profile-page__who h4.ant-typography {
  margin-bottom: var(--ds-space-1);
  overflow-wrap: anywhere;
}

.profile-page__who .ant-typography,
.profile-page__who p,
.profile-page__value {
  overflow-wrap: anywhere;
}

.profile-page__who p {
  margin: var(--ds-space-2) 0 0;
}

.profile-page .ant-tabs > .ant-tabs-nav {
  margin-bottom: var(--ds-space-3);
}

@media (max-width: 575.98px) {
  /* Label above value: the value column follows directly under its label. */
  .profile-page__value {
    margin-top: calc(-1 * var(--ds-space-2));
    padding-bottom: var(--ds-space-2);
    border-bottom: 1px solid var(--ds-border-soft);
  }
}
`, "",{"version":3,"sources":["webpack://./src/normalUsers/components/profile/ProfilePage.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0EAA0E;EAC1E;IACE,wCAAwC;IACxC,iCAAiC;IACjC,8CAA8C;EAChD;AACF","sourcesContent":["/* Own-profile pages (client, admin, subadmin). Scoped under .profile-page. */\n\n.profile-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n  min-width: 0;\n}\n\n.profile-page__identity {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-4);\n  min-width: 0;\n}\n\n.profile-page__identity .ant-avatar {\n  flex-shrink: 0;\n}\n\n.profile-page__who {\n  min-width: 0;\n}\n\n.profile-page__who h4.ant-typography {\n  margin-bottom: var(--ds-space-1);\n  overflow-wrap: anywhere;\n}\n\n.profile-page__who .ant-typography,\n.profile-page__who p,\n.profile-page__value {\n  overflow-wrap: anywhere;\n}\n\n.profile-page__who p {\n  margin: var(--ds-space-2) 0 0;\n}\n\n.profile-page .ant-tabs > .ant-tabs-nav {\n  margin-bottom: var(--ds-space-3);\n}\n\n@media (max-width: 575.98px) {\n  /* Label above value: the value column follows directly under its label. */\n  .profile-page__value {\n    margin-top: calc(-1 * var(--ds-space-2));\n    padding-bottom: var(--ds-space-2);\n    border-bottom: 1px solid var(--ds-border-soft);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
